import { render, staticRenderFns } from "./OftalmologiaView.vue?vue&type=template&id=6ca4a82c"
import script from "./OftalmologiaView.vue?vue&type=script&lang=js"
export * from "./OftalmologiaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports